import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Link, useLocation } from 'react-router-dom';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { clearAllDraftsOnLogout } from 'utils/vehicleDraftDB';
import { ArrowBottom, ArrowLeft, LogoutIcon, MenuIcon } from 'assets/icons';
import { Logo } from 'assets/img';
import { MenuItem } from './menu';

interface Props {
	className?: string;
	toggleSidebar?: any;
	toggleResponsive?: any;
}

const logout = (dispatch: any, history: any, userId?: string) => {
	Globals.confirm('¿Desea cerrar sesión?', async () => {
		// Limpiar drafts del usuario antes de cerrar sesión
		if (userId) {
			await clearAllDraftsOnLogout(userId);
		}
		
		dispatch({ type: 'SET_USER', payload: null });
		dispatch({ type: 'SET_ACCESS_TOKEN', payload: null });
		history.replace('/login');
		Globals.quitLoading();
	});
}


const findMenuItem = (path: string, items: MenuItem[]): MenuItem | undefined => {
	for (const item of items) {
		if (item.submenu) {
			const found = findMenuItem(path, item.submenu);
			if (found) {
				return found;
			}
		}
		if (item.path === path) {
			return item;
		}
	}
	return undefined;
};

const Header = (props: Props) => {
	const header = useSelector((state: RootState) => state.header);
	const subheader = useSelector((state: RootState) => state.subheader);
	const user = useSelector((state: RootState) => state.user);
	const location = useLocation();
	const photo = user?.user_documents?.find((i: any) => i.document_type_id == Constants.DOCUMENT_TYPES.PHOTO)?.file;

	const userInitials = useMemo(() => {
		return Globals.getInitials(user?.name);
	}, [user]);

	return (
		<div id="header" className={props.className}>
			<div className="container-blue-top">
				<button className="navbar-toggler responsive" type="button" onClick={() => props.toggleResponsive()}>
					<img src={MenuIcon} alt="" />
				</button>
				<div className="container-logo">
					<div className="pill">
						<div className="pill-logo">
							<Link to="/">
								<img src={ photo ? Globals.fromPhotos(photo) : Logo} alt="" />
							</Link>
							<Link to="/" className="responsive">
								<img src={ photo ? Globals.fromPhotos(photo) : Logo} alt="" />
							</Link>
						</div>
						{/*<div className="pill-actions">
							<div className="pill-btn" onClick={() => {}}>
								<img src={ArrowBottom} alt="" />
							</div>
						</div>*/}
					</div>
				</div>
				<div className="container-back-top">
					<button className="navbar-toggler" type="button" onClick={() => props.toggleSidebar()}>
						<img src={MenuIcon} alt="" />
					</button>
					{
						header.onBack && (
							<div className="arrow-back" onClick={header.onBack}>
								<img src={ArrowLeft} alt="" />
							</div>
						)
					}
					<div className="container-titles">
						<h3 className="title-top">{header.title}</h3>
						<h4 className="subtitle-top">{subheader.title}</h4>
					</div>
				</div>
				<div className="container-buttons-top">
					<div className="container-buttons-web">
						<Link to="/profile">
							<button className="profile">
								<span>{ userInitials }</span>
							</button>
						</Link>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Header;